const style = {
  main: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      p: 2,
    },
  },
  label: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      '& span': {
        fontWeight: 600,
      },
    },
  },
  chip: {
    sx: { m: 1 },
    variant: 'outlined',
  },
} as const;

export default style;
